var _style, _ellipse, _g, _g2, _g3, _g4, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _ellipse7, _ellipse8, _g5, _g6, _g7, _ellipse9, _path3, _ellipse10, _ellipse11, _ellipse12, _g8, _path4, _path5, _path6, _path7, _path8, _ellipse13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "456px",
    height: "213px",
    viewBox: "0 0 456 213",
    style: {
      enableBackground: "new 0 0 456 213"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F5C7C7;}\r\n\t.st1{fill:#984A59;}\r\n\t.st2{fill:#E59C9C;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.9,
    cy: 36.5,
    rx: 20.5,
    ry: 20.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.1,75.8c4.5,2.5,8.4,6.2,11.1,11l32.6,69.9c8.3,14.3,3.4,32.6-10.9,40.8c-14.3,8.3-32.6,3.4-40.9-10.9 l-32.6-69.9c-8.3-14.3-3.4-32.6,10.9-40.8C212.9,70.5,224.2,70.8,233.1,75.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,143.5c4.2-2.9,9.3-4.8,14.8-5.2l17.4,1.1c16.5-1.2,30.9,11.1,32.1,27.5c1.3,16.5-11.1,30.8-27.6,32.1 l-17.4-1.1c-16.5,1.2-30.9-11.1-32.1-27.5C182.3,159.4,187.5,149.4,196,143.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.2,151.7c6.4,0,8.9,16,8.4,9.6c-1.4-15.8-10.7-60.7-11.9-71.1c-1.3-10.6-10.2-23.8-19.5-29.2 c-33.8-19.4-58.7-1-64,30c-3.3,19.6-25.6,59.5-5.6,59.5C163.6,150.5,194.5,151.7,242.2,151.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.7,73c0.5,4.1,0.1,8.3-1.6,12.3l-13.9,27.9c-5,12.1-18.9,17.8-30.9,12.7c-12.1-5-17.8-18.9-12.7-30.9 l13.9-27.9c5-12.1,18.9-17.8,30.9-12.7C165.4,57.7,170.6,65,171.7,73z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 191.7,
    cy: 66.9,
    rx: 31.9,
    ry: 31.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 194.7,
    cy: 64.5,
    rx: 31.9,
    ry: 31.9
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.2,
    cy: 32.6,
    rx: 20.5,
    ry: 20.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.2,
    cy: 21.6,
    rx: 20.5,
    ry: 20.4
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.1,
    cy: 58.5,
    rx: 20.5,
    ry: 20.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.1,156.3h-12.6c-9,0-16.3-7.3-16.3-16.3l0,0c0-9,7.3-16.3,16.3-16.3h12.6c9,0,16.3,7.3,16.3,16.3l0,0 C301.4,149,294.1,156.3,285.1,156.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.5,205.2h-67.3c-9,0-16.4-7.3-16.4-16.4v-39.9c0-9,7.3-16.4,16.4-16.4h67.3c9,0,16.4,7.3,16.4,16.4v39.9 C327.9,197.9,320.5,205.2,311.5,205.2z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.1,
    cy: 57.4,
    rx: 6.5,
    ry: 6.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.1,
    cy: 68.4,
    rx: 6.5,
    ry: 6.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.5,144.9c-2.6,0-5-1.7-5.8-4.4c-3.5-12.4,3.5-21,8.1-24.2c2.7-1.9,6.5-1.1,8.3,1.6s1.2,6.4-1.5,8.3 c-0.6,0.4-5.3,4.1-3.4,11.1c0.9,3.2-1,6.5-4.1,7.4C276.6,144.8,276,144.9,275.5,144.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.1,140.2c-2.5,0-4.8-1.5-5.6-4c-4-11.2,3.7-19,8.3-21.6c2.9-1.6,6.5-0.6,8.2,2.3c1.6,2.9,0.6,6.5-2.2,8.1 c-1.1,0.6-4.4,3-2.9,7.2c1.1,3.1-0.5,6.5-3.6,7.6C269.5,140.1,268.8,140.2,268.1,140.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.5,142.7c-3.2,0-5.5-2.5-5.5-5.7c0-7,1.7-10.2,4-14c3.2-5.2,11.2-6.7,13.1-0.3c1.5,5-2.6,10.3-5.6,13.8 c-2.2,2.5-2.4,6.1-5.7,6.3C284.7,142.7,284.6,142.7,284.5,142.7z"
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 166.3,
    cy: 58,
    rx: 10,
    ry: 9.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.1,53.8c0.8-10.9,3-21.8,13.8-20.1c15,2.3,52,8.3,58.9,9.2c8,1.1,14.3,7.8,14.2,15.8 c-0.1,3.3-1.2,6.7-4.3,9.8c-3,3-7,4.8-11.2,5.2l-57.6,5.8c-11.6,1.1-15-10.4-14.1-22L86.1,53.8z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 97.7,
    cy: 56.7,
    rx: 23,
    ry: 22.9
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 97.7,
    cy: 56.7,
    rx: 17.9,
    ry: 17.8
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 95.7,
    cy: 55.7,
    rx: 10,
    ry: 9.9
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.1,143.5c4.2-2.9,9.3-4.8,14.8-5.2l17.4,1.1c16.5-1.2,30.9,11.1,32.1,27.5c1.3,16.5-11.1,30.8-27.6,32.1 l-17.4-1.1c-16.5,1.2-30.9-11.1-32.1-27.5C123.4,159.4,128.6,149.4,137.1,143.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 965.6513,
    y1: 899.1883,
    x2: 965.6513,
    y2: 837.7859,
    gradientTransform: "matrix(1 0 0 1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F6FA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1175.1,1102.8c10.7-0.2,19.2-9,18.9-19.6c-0.2-10.6-9.1-19-19.7-18.8c-3.7,0.1-7.1,1.2-10,3 c-4.3-5.9-11.3-9.7-19.1-9.5c-8.8,0.2-16.3,5.2-20,12.4c-3.3-6.9-9.9-11.9-17.7-12.8c-3.5-8.5-12-14.2-21.7-14 c-8.9,0.2-16.4,5.4-20.1,12.7c-0.8-0.1-1.7-0.1-2.6-0.1c-10.4,0.2-19,7.3-21.7,16.7c-3.3-1.2-6.9-1.9-10.6-1.8 c-11,0.2-20.3,6.5-25,15.5c-4.1-8.6-12.4-14.8-22.2-16.1c-4.4-10.6-15-17.8-27.1-17.6c-11.1,0.2-20.6,6.7-25.2,15.9 c-1.1-0.1-2.1-0.1-3.2-0.1c-1.5,0-3.1,0.2-4.5,0.5c-4.5-5.5-11.5-9-19.2-8.8c-4.6,0.1-8.9,1.5-12.5,3.8 c-5.3-7.4-14.1-12.1-23.9-11.9c-11,0.2-20.3,6.5-25,15.5c-4.1-8.6-12.4-14.8-22.2-16.1c-4.4-10.6-15-17.8-27.1-17.6 c-11.1,0.2-20.6,6.7-25.2,15.9c-1.1-0.1-2.1-0.1-3.2-0.1c-15.9,0.3-28.3,13.3-28,29.1c0.2,10.2,5.8,18.9,13.9,23.8L1175.1,1102.8 z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.1512,
    y1: 30,
    x2: 227.1512,
    y2: -38.7217,
    gradientTransform: "matrix(1 0 0 1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F6FA"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M436.6,212c10.7-0.2,19.2-9,18.9-19.6c-0.2-10.6-9.1-19-19.7-18.8c-3.7,0.1-7.1,1.2-10,3 c-4.3-5.9-11.3-9.7-19.1-9.5c-8.8,0.2-16.3,5.2-20,12.4c-3.3-6.9-9.9-11.9-17.7-12.8c-3.5-8.5-12-14.2-21.7-14 c-8.9,0.2-16.4,5.4-20.1,12.7c-0.8-0.1-1.7-0.1-2.6-0.1c-10.4,0.2-19,7.3-21.7,16.7c-3.3-1.2-6.9-1.9-10.6-1.8 c-11,0.2-20.3,6.5-25,15.5c-4.1-8.6-12.4-14.8-22.2-16.1c-4.4-10.6-15-17.8-27.1-17.6c-11.1,0.2-20.6,6.7-25.2,15.9 c-1.1-0.1-2.1-0.1-3.2-0.1c-1.5,0-3.1,0.2-4.5,0.5c-4.5-5.5-11.5-9-19.2-8.8c-4.6,0.1-8.9,1.5-12.5,3.8 c-5.3-7.4-14.1-12.1-23.9-11.9c-11,0.2-20.3,6.5-25,15.5c-4.1-8.6-12.4-14.8-22.2-16.1c-4.4-10.6-15-17.8-27.1-17.6 c-11.1,0.2-20.6,6.7-25.2,15.9c-1.1-0.1-2.1-0.1-3.2-0.1c-15.9,0.3-28.3,13.3-28,29.1c0.2,10.2,5.8,18.9,13.9,23.8L436.6,212z"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.3,74.7c-0.9,3.5,3.1,0.1,6.6,1s5.1,5.8,6,2.3s-1.1-7-4.6-8S173.2,71.3,172.3,74.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.1,57.5c0.7,1.4,1-0.8,2.4-1.5c1.4-0.7,3.3,0.4,2.6-1c-0.7-1.4-2.4-1.9-3.7-1.2C199.1,54.5,198.4,56.2,199.1,57.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.7,48.3c-0.7,1.4,1.3,0.3,2.7,1c1.4,0.7,1.6,2.8,2.3,1.5c0.7-1.4,0.1-3-1.3-3.7C176.1,46.3,174.4,46.9,173.7,48.3z"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 192.5,
    cy: 67.3,
    rx: 2,
    ry: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobs);
export default __webpack_public_path__ + "static/media/no-jobs.14ea8754afe3c5549914dcc4739e55b4.svg";
export { ForwardRef as ReactComponent };